/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据文件地址批量删除文件
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  filesPath: Array<string>,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<string>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/oss/fileList`,
    data: filesPath,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
